import React from "react";

const Tooltip = ({ children, className, open, ...props }) => {
  return (
    <p
      {...props}
      className={`h-fit max-w-full ${
        open ? "block" : "hidden"
      } group-hover:block absolute bottom-[110%] bg-gray-400 p-2 rounded left-0 ${className}`}
    >
      {children}
    </p>
  );
};

export default Tooltip;
